import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import StatePicker from 'app/directives/state.picker';
import TanksPicker from 'app/directives/tanks.picker';
import MappingComponent from 'app/admin/components/mapping.component';

import {HomeCtrl, CompanyHomeCtrl} from './ctrls';
import homeTpl from './templates/main.html';
import companyHomeTpl from './templates/main.plants.html';


@Module({
    name: 'app.admin.home',
    modules: [
        BaseRoute,
        StatePicker,
        TanksPicker,
        MappingComponent,
    ],
})
@State({
    name: 'r.in.top.admin.home',
    url: '',
    controller: HomeCtrl,
    template: homeTpl,
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'r.in.top.admin.company',
    url: '/{companyId:int}',
    template: '<div ui-view></div>',
    resolve: {
        $company: function ($stateParams, CompanyStore) {
            return CompanyStore.get($stateParams.companyId);
        },
    },
    controller: function ($company) {
        "ngInject";
        this.company = $company;
    },
    ncyBreadcrumb: {
        label: '{{ vm.company.name }}',
        parent: 'r.in.top.admin',
    },
    data: {
        permissions: {
            only: [
                'main.view_company',
            ],
        },
    },
    abstract: '.detail',
})
@State({
    name: 'r.in.top.admin.company.detail',
    url: '',
    controller: CompanyHomeCtrl,
    template: companyHomeTpl,
    ncyBreadcrumb: {
        skip: true,
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/home/routing.js